import { RENDERER_TYPES } from "../../enums";

const ACTIVITY_LOG_COLUMNS = [
  {
    title: "Date & Time",
    field: "updatedAt",
    dataType: "string",
    width: "20%",
    rendererType: RENDERER_TYPES.FULL_DATE,
  },
  {
    title: "User",
    field: "actionPerformBy",
    dataType: "string",
    width: "20%",
    rendererType: RENDERER_TYPES.FULL_NAME,
  },
  {
    title: "User Role",
    field: "userRole",
    dataType: "string",
    rendererType: "role",
    width: "20%",
  },
  {
    title: "Activity",
    field: "activity",
    dataType: "string",
    width: "27%",
    rendererType: "invitation_activity",
  },
  {
    title: "Visited",
    field: "isVisited",
    dataType: "boolean",
    width: "8%",
    rendererType: "activity_log_visited",
  },
  { title: "Actions", rendererType: RENDERER_TYPES.ACTION, width: "5%" },
];

export { ACTIVITY_LOG_COLUMNS };
